import React, { useState } from "react";
import styles from "./styles.module.scss";
import { IoIosLink } from "react-icons/io";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import { HiOutlineMail } from "react-icons/hi";
import { PiPhone } from "react-icons/pi";
import { SlLocationPin } from "react-icons/sl";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { BsTelephoneOutbound } from "react-icons/bs";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const notifySucces = () =>
    toast.success("Your message has been sent successfully.");
  const notifyError = () =>
    toast.error("There is an error, and we will work on resolving it.");
  const notifyMandatory = () =>
    toast.error("Please fill in all the required fields.");

  const handlerSubmit = () => {
    if (email && name && message) {
      emailjs
        .send(
          "service_pugqg18",
          "template_xhdrrn7",
          {
            from_name: name,
            email: email,
            message: message,
            phone: phone,
          },
          { publicKey: "M3065wquUKVT_UZUp" }
        )
        .then(
          () => {
            notifySucces();
            setEmail("");
            setName("");
            setMessage("");
            setPhone("");
          },
          (error) => {
            notifyError();
          }
        );
    } else {
      notifyMandatory();
    }
  };

  return (
    <div className={styles.ContactPage}>
      <ToastContainer />
      <div className={styles.top_header}>
        <div className={styles.headerBTN}>
          <IoIosLink /> <span>Contact Me</span>
        </div>
        <p>Let's talk! </p>
      </div>
      <Row>
        <Col  md={12} lg={6}>
          <div className={styles.formContact}>
            <Row className={styles.form}>
              <Col xs="12" className={styles.feild}>
                <Form.Label htmlFor="inputPassword5">
                  Full Name <span className={styles.mandetory}>*</span>
                </Form.Label>
                <InputGroup className="mb-3">
                  <Form.Control
                    aria-describedby="basic-addon1"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                  />
                </InputGroup>
              </Col>
              <Col md="6" className={styles.feild}>
                <Form.Label htmlFor="inputPassword5">
                  Email <span className={styles.mandetory}>*</span>
                </Form.Label>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="basic-addon1">
                    <HiOutlineMail />
                  </InputGroup.Text>
                  <Form.Control
                    aria-describedby="basic-addon1"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                  />
                </InputGroup>
              </Col>
              <Col md="6" className={styles.feild}>
                <Form.Label htmlFor="inputPassword5">Phone</Form.Label>
                <InputGroup className="mb-3">
                  <InputGroup.Text id="basic-addon1">
                    <PiPhone />
                  </InputGroup.Text>
                  <Form.Control
                    aria-describedby="basic-addon1"
                    onChange={(e) => setPhone(e.target.value)}
                    value={phone}
                  />
                </InputGroup>
              </Col>
              <Col xs="12" className={styles.feild}>
                <Form.Label htmlFor="inputPassword5">
                  Message <span className={styles.mandetory}>*</span>
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    as="textarea"
                    aria-label="With textarea"
                    rows={4}
                    onChange={(e) => setMessage(e.target.value)}
                    value={message}
                  />
                </InputGroup>
              </Col>

              <div className="mt-5">
                <button
                  className={styles.btnForm}
                  onClick={() => handlerSubmit()}
                >
                  Send Message
                </button>
              </div>
            </Row>
          </div>
        </Col>

        <Col  md={12} lg={6}>
          <div className={`${styles.contact_info} mt-5`}>
            <div className={styles.contact_items}>
              <div className={styles.contact_item_top}>
                <div className={styles.title}>
                  <SlLocationPin /> <span>Address</span>
                </div>
                <div className={styles.content}>Amman, Jordan</div>
              </div>
              <div className={styles.contact_item_bottom}>
                <div className={styles.contact_item_bottom_sub}>
                  <div className={styles.title}>
                    <BsTelephoneOutbound />
                    <span>Phone</span>
                  </div>
                  <div className={styles.content}>+962770718344</div>
                </div>
                <div className={styles.contact_item_bottom_sub}>
                  <div className={styles.title}>
                    <MdOutlineMarkEmailRead />
                    <span>Email</span>
                  </div>
                  <div className={styles.content}>mahmoud.odah08@gmail.com</div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Contact;
